<template>
  <span><!-- placeholder --></span>
</template>

<script>
/**
 * Note: Forte.js from vendor is meant to be included as <script src=...> in an HTML page. It is not "exported."
 * So, it needs to be "loaded" as it cannot be "imported" via JavaScript directly.
 *
 * Also, the Forte library will NOT load in this component. Thus, it is preloaded in its parent (Payment).
 */
import { mapActions } from 'vuex';
import getForteConfig from './forteConfig';

export default {
  name: 'OneTimeToken',
  parent: 'Payment',
  props: {
    cardNumber: {
      type: String,
      required: true,
    },
    cardMonth: {
      type: String,
      required: true,
    },
    cardYear: {
      type: String,
      required: true,
    },
    cardCvv: {
      type: String,
      required: true,
    },
    fetchToken: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      ftConfig: {},
    };
  },
  computed: {
    // ...mapState([
    //   'reservationSlotId',
    // ]),
  },
  watch: {
    fetchToken() {
      // console.log('TXNID', fetchToken)
      if (this.fetchToken) {
        this.getOtt();
      }
    },
  },
  methods: {
    ...mapActions([
      // 'setStoreProperty'
    ]),
    /**
     * Get one time token from Forte based on credit card info.
     */
    async getOtt() {
      this.setLoading(true);

      // credit card only
      const data = {
        api_login_id: getForteConfig().key,
        card_number: this.cardNumber,
        expire_month: this.cardMonth,
        expire_year: this.cardYear,
        cvv: this.cardCvv,
      };

      // forte doesn't have a .finally event
      // eslint-disable-next-line
      forte.createToken(data)
          .success(this.ottSuccess)
          .error(this.ottError);
    },
    /**
     * Get OTT from Forte. (But it does not necessarily mean the OTT is good for payment, e.g. Forte still
     * return OTT with success status even if user inputs an unsupported credit card.)
     * @param res
     * @returns {Promise<void>}
     */
    ottSuccess(res) {
      this.setLoading(false);
      this.$emit('doPay', {
        hasOtt: true,
        forte: res,
      });
    },
    /**
     * Cannot get OTT.
     * @param res
     */
    ottError(res) {
      this.setLoading(false);
      this.$emit('doPay', {
        hasOtt: false,
        forte: res,
      });
    },
    setLoading(loading) {
      console.log(loading);
    }
  }
};
</script>
